var imagesLoaded = require('imagesloaded');

const setLoaded = () => {
  document.documentElement.classList.remove('loading');
  imagesLoaded( document.querySelector('body'), function( instance ) {
    document.body.classList.add('imagesLoaded');
  });
}

export default setLoaded;